import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Chauffeur from "./sections/Chauffeur";
import Differentiators from "./sections/Differentiators";
import ArchitectsOfArrival from "./sections/ArchitectsOfArrival";
import Reservation from "./sections/Reservation";
import Biography from "./sections/Biography";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Chauffeur />
      <Differentiators />
      <ArchitectsOfArrival />
      <Biography />
      <Reservation />
      <Footer />
    </div>;
}